import { gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg6, useTableColumnsInventario } from "@/shared";
import { CustomTextFieldNoForm, SampleCheckbox, TabTextLabel, SampleTable } from "@/shared/components/ui";
import { Grid } from "@mui/material";
import { FormAgendaCorporativo, IVentaCorporativoNoc } from "./SaveAgendamientoNoc";
import { UseFormReturn } from "react-hook-form";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";

interface TabInformacionAdicionalAgendaNocProps {
  noForm: IVentaCorporativoNoc | null
  form: UseFormReturn<FormAgendaCorporativo, any, FormAgendaCorporativo>
}

export default function TabInformacionAdicionalAgendaNoc({
  noForm,
  form
}: TabInformacionAdicionalAgendaNocProps) {

  const serviciosAdicionalesDigitales = useMaterialesUtilizadosStore(
    (s) => s.serviciosAdicionalesDigitales
  );

  const { columnsItemServiciosDigitalesFactibilidad } = useTableColumnsInventario({
    key: MaterialesKey.serviciosAdicionalesDigitales,
  });

  return (
    <>
      <Grid container spacing={3}>

        <Grid item  {...gridSizeMdLg12} >
          <TabTextLabel text="Características del Enlace" mt={0} pb={1} pl={0} pt={0} />
        </Grid>

        <CustomTextFieldNoForm
          size={gridSizeMdLg6}
          label={"Medio / Última Milla"}
          defaultValue={noForm?.medio_ultima_milla}
          disabled={true}
        />

        <SampleCheckbox
          size={gridSizeMdLg3}
          label="Energía Regulada"
          control={form.control}
          name="energia_regulada"
          defaultValue={noForm?.energia_regulada || false}
          disabled={true}
        />

        <SampleCheckbox
          size={gridSizeMdLg3}
          label="Espacio Para Equipos"
          control={form.control}
          name="espacio_equipos"
          defaultValue={noForm?.espacio_equipos || false}
          disabled={true}
        />

        <CustomTextFieldNoForm
          size={gridSizeMdLg6}
          label={"Tipo de Puertos para Recibir el Servicio"}
          defaultValue={noForm?.tipo_puerto_disponible}
          disabled={true}
        />

        <SampleCheckbox
          size={gridSizeMdLg3}
          label="Zona Soterrada"
          control={form.control}
          name="zona_soterrada"
          defaultValue={noForm?.zona_soterrada || false}
          disabled={true}
        />

        <SampleCheckbox
          size={gridSizeMdLg3}
          label="Instalación por Ductos"
          control={form.control}
          name="instalacion_ductos"
          defaultValue={noForm?.instalacion_ductos || false}
          disabled={true}
        />

        <Grid item  {...gridSizeMdLg12} >
          <TabTextLabel text="Ubicación" mt={0} pb={1} pl={0} pt={0} />
        </Grid>

        <CustomTextFieldNoForm
          defaultValue={noForm?.coordenada_empresa}
          size={gridSizeMdLg6}
          label={"Coordenadas Empresa"}
          disabled
        />

        <CustomTextFieldNoForm
          defaultValue={noForm?.direccion_empresa}
          size={gridSizeMdLg6}
          label={"Dirección Empresa"}
          disabled
        />

        <CustomTextFieldNoForm
          defaultValue={noForm?.coordenada_fusion}
          size={gridSizeMdLg6}
          label={"Coordenadas Fusión"}
          disabled
        />

        <CustomTextFieldNoForm
          defaultValue={noForm?.direccion_fusion}
          size={gridSizeMdLg6}
          label={"Dirección Fusión"}
          disabled
        />

        <Grid item  {...gridSizeMdLg12} >
          <TabTextLabel text="Detalle IPs" mt={0} pb={0} pl={0} />
        </Grid>
        <CustomTextFieldNoForm
          defaultValue={noForm?.num_ips_publicas}
          size={gridSizeMdLg6}
          label={"Número de IPs públicas"}
          disabled
        />

        <CustomTextFieldNoForm
          defaultValue={noForm?.num_ips_publicas_facturadas}
          size={gridSizeMdLg6}
          label={"Número de IPs públicas Facturadas"}
          disabled
        />

        <CustomTextFieldNoForm
          defaultValue={noForm?.costo_valor_ip_facturado}
          size={gridSizeMdLg6}
          label={"Valor IPs Facturadas ($)"}
          disabled
        />

        <CustomTextFieldNoForm
          value={
            noForm?.num_ips_publicas_facturadas && noForm?.costo_valor_ip_facturado ?
              ((parseFloat(noForm?.num_ips_publicas_facturadas) || 0) * (noForm?.costo_valor_ip_facturado || 1)).toString()
              : "0"
          }
          size={gridSizeMdLg6}
          label={'Valor a Pagar ($)'}
          disabled={true}
        />

        <Grid item  {...gridSizeMdLg12} >
          <TabTextLabel text="Servicios Adicionales" mt={0} pb={0} pl={0} />
        </Grid>
        <Grid item container spacing={2} {...gridSizeMdLg12}>
          <SampleTable<any>
            // rowNumber={true}
            columns={columnsItemServiciosDigitalesFactibilidad}
            data={
              serviciosAdicionalesDigitales//.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.SERVICIOS_DIGITALES)
              ||[]
            }
          />
        </Grid>
        

        {/* <Grid item container spacing={2} {...gridSizeMdLg4}>
          <SampleCheckbox
            label='Seguridad Perimetral'
            control={form.control}
            name='seguridad_perimetral'
            defaultValue={noForm?.seguridad_perimetral || false}
            size={gridSizeMdLg12}
            disabled
          />

          <CustomNumberTextField
            control={form.control}
            name="costo_seguridad_perimetral"
            defaultValue={noForm?.costo_seguridad_perimetral}
            size={gridSizeMdLg12}
            label={'Costo Seguridad Perimetral'}
            error={undefined}
            helperText={undefined}
            disabled={true}
            sxInputText={{ mt: 1 }}
          />
        </Grid>
        <Grid item container spacing={2} {...gridSizeMdLg4}>
          <SampleCheckbox
            size={gridSizeMdLg12}
            label='Wifi Gestionado'
            control={form.control}
            name='wifi_gestionado'
            defaultValue={noForm?.wifi_gestionado || false}
            disabled
          />
          <CustomNumberTextField
            control={form.control}
            name="costo_wifi_gestionado"
            defaultValue={noForm?.costo_wifi_gestionado}
            size={gridSizeMdLg12}
            label={'Costo Wifi Gestionado'}
            error={undefined}
            helperText={undefined}
            disabled={true}
            sxInputText={{ mt: 1 }}
          />

        </Grid>
        <Grid item container spacing={2} {...gridSizeMdLg4}>
          <SampleCheckbox
            size={gridSizeMdLg12}
            label='Cableado Interno'
            control={form.control}
            name='cableado_interno'
            defaultValue={noForm?.cableado_interno || false}
            disabled
          />
          <CustomNumberTextField
            control={form.control}
            name="costo_cableado_interno"
            defaultValue={noForm?.costo_cableado_interno}
            size={gridSizeMdLg12}
            label={'Costo Cableado Interno'}
            error={undefined}
            helperText={undefined}
            disabled={true}
            sxInputText={{ mt: 1 }}
          />
        </Grid> */}

      </Grid>
    </>
  )

}